import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { useI18n } from '@/i18n/useI18n';
import { HOME_PATH } from '@/layout/nav';
import { Card, CardBody } from '@/ui/Card';

export function NotFoundPage(): ReactNode {
  const { t } = useI18n();
  return (
    <Card className="mx-auto max-w-xl">
      <CardBody className="space-y-3">
        <h1 className="text-lg font-semibold text-ink">{t('notFound.title')}</h1>
        <p className="text-sm text-ink-muted">{t('notFound.detail')}</p>
        <Link
          to={HOME_PATH}
          className="inline-block text-sm font-medium text-accent underline underline-offset-2"
        >
          {t('guard.forbidden.back')}
        </Link>
      </CardBody>
    </Card>
  );
}
